export enum SearchAndSelectColumnId {
    checkbox = "checkbox",
    name = "name",
    id = "ID",
    mediaType = "mediaType",
    tags = "tags",
    plays = "plays",
    views = "views",
    creationDate = "creationDate",
    updateDate = "updateDate",
    createdBy = "createdBy",
}
